import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ISignatureInputModel, ISignatureOutputModel } from 'src/app/ViewModel/CommunicationModel';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { CommonService } from 'src/app/Service/Common.service';
@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.css']
})
export class SignatureComponent implements OnInit {
  signatureText: string = '';
  isNew: boolean = false;
  memberId: number = 0;
  selectedId: number = 0;

  public signatureList: ISignatureOutputModel[] = [];
  public signatureForm: FormGroup = new FormGroup({
    editor: new FormControl(),
    txtSignatureName: new FormControl(),
  });
  constructor(private http: HttpClient,
    public commonService: CommonService,
    private _communicationService: CommunicationService,
    private _notificationService: NotificationService,
    public dialogRef: MatDialogRef<SignatureComponent>) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.getSignatureList();
  }

  closeDialog(data:any) {
    this.dialogRef.close(data);
  }
  /**
  * Get Form Control value
  * @param controlName ControlName
  */
  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }
  /**
 * Get Signatures List
 */
  public getSignatureList() {
    this._communicationService.GetSignatureList({ MemberId: this.memberId })
      .subscribe((res: ISignatureOutputModel[]) => {
        this.signatureList = res;
      }, err => { });
  }

  createSignature() {
    this.isNew = true;
  }

  saveSignature() {

    let signatureName=this.getFormValue('txtSignatureName', this.signatureForm);
if(!!signatureName){
    let inputModel: ISignatureInputModel = {
      MemberId: this.memberId,
      SignatureId: this.selectedId,
      SignatureName: signatureName,
      SignatureText: this.getFormValue('editor', this.signatureForm),
      IsActive: true
    };
    this.callService(inputModel);
    this.reset();
  }
  else{
    this._notificationService.showToast("Please Enter Signature", "Warning");
  }
  }

  editSignature(sign: any) {
    this.isNew = true;
    this.reset();
    this.selectedId = sign.signatureId;
    this.signatureForm.controls['txtSignatureName'].setValue(sign.signatureName);
    this.signatureForm.controls['editor'].setValue(sign.signatureText);
  }

  deleteSignature(sign: any) {
    let inputModel: ISignatureInputModel = {
      MemberId: this.memberId,
      SignatureId: sign.signatureId,
      SignatureName: sign.signatureName,
      SignatureText: sign.signatureText,
      IsActive: false
    };
    this.callService(inputModel);
  }

  callService(inputModel: ISignatureInputModel) {
    this._communicationService.InsertSignature(inputModel).subscribe((res: StandardOutputModel) => {
      this.isNew = false;
      if (res.successCode == 200 || res.successCode == 205) {
        this._notificationService.showToast(res.successMessage, "Success");
      }
      else {
        this._notificationService.showToast(res.successMessage, "Error");
      }
      this.getSignatureList();
    });
  }
  reset() {
    this.signatureForm.controls['txtSignatureName'].setValue('');
    this.signatureForm.controls['editor'].setValue('');
    this.selectedId = 0;

  }

  postSignature(){
    this.closeDialog(this.getFormValue('editor', this.signatureForm));
  }
}




